module.exports = __webpack_public_path__ + "static/media/photo-1539192009026-4163d2da8925.2ef8ddfe.jpg";